if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"HCIDWebsite","remotes":[{"alias":"HCIDPosLocator","name":"HCIDPosLocator","entry":"https://api-uat.homecredit.co.id/pos-locator-web/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(9(030|473|710)|(224|358|567|696)1|1823|2346|4480|5445|8772)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}